import {DOM} from "../../../../public/js/utils/DOM";
import {IFilterRequest} from "../../Form/definitions/IFilterRequest";
import {ControlsGeneralEasyFilterControl} from "../EasyFilterControl/EasyFilterControl";
import {ControlsGeneralFilterControl} from "../FilterControl/FilterControl";
import {Table} from "../../../../public/js/utils/Table";
import {DropDownControl} from "../DropDownControl/DropDownControl";
import {IFormFilterRequest} from "../../Form/definitions/IFormFilterRequest";
import {Networking} from "../../../../public/js/utils/Netwtorking";
import {RequestTypes} from "../../../../public/js/definitions/utils/networking/RequestTypes";
import {LinkBuilder} from "../../../../public/js/utils/LinkBuilder";
import {ControlsForm} from "../../Form/Form";
import {FormValidator} from "../../../../public/js/utils/Validator/FormValidator";

export namespace ControlsGeneralTableControl {

    import SortingPayload = Table.SortingPayload;

    export class Config {

        public static readonly triggerRowTitle = 'TableControl-mobile-content-item-main';
        public static readonly openedRowClassName = 'opened';
        public static readonly tableControlElementClassName = "TableControl";
        public static readonly copyColumnClassName = 'columnCopy';
        public static readonly copyColumnButtonClassName = 'columnCopy-btn';
        public static readonly copyColumnContentClassName = 'columnCopy-content';
        public static readonly copyColumnCopiedClassName = 'copied';
    }

    export class Filter {

        /**
         * Initialize trigger on easy filter functionality
         * @param filterRequest - always required filtering params
         * @param easyFilterId - easy filter id
         * @param filterId - filter ID if required
         * @param dropdownId - dropdown ID if required
         */
        private static triggerEasyFilterFilter(filterRequest: IFilterRequest, easyFilterId: string, filterId?: string, dropdownId?: string) : void {

            ControlsGeneralEasyFilterControl.Control.initialize({
                easyFilterId: easyFilterId,
                callback: (actionTypeId: number, event: MouseEvent) => {
                    void this.sendFilterRequest({
                        filter: filterId ? ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId) : null,
                        linkParams: {component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: []},
                        page: 0,
                        sorting: Table.Helpers.getSorting(filterRequest.tableId),
                        event: event,
                        dropDownValue: dropdownId ? DropDownControl.Control.getCurrentDropDownValue(dropdownId) : null,
                        easyFilterTypeId: actionTypeId,
                        completedCallback: () => { filterRequest.successCallback(); }
                    });
                }
            })
        }

        /**
         * Trigger change dropdown functionality
         * @param filterRequest - always required filtering params
         * @param dropdownId - dropdown element ID
         * @param filterId - filter id if required
         * @param easyFilterId - easy filter ID if required
         */
        private static triggerDropdownFilter(filterRequest: IFilterRequest, dropdownId: string, filterId?: string, easyFilterId?: string) : void {

            if (document.getElementById(dropdownId)) {
                DropDownControl.Control.trigger(dropdownId, (valueToPropagate: string | number | null, event: MouseEvent) => {
                    void this.sendFilterRequest({
                        filter: filterId ? ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId) : null,
                        linkParams: {component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: []},
                        page: 0,
                        sorting: Table.Helpers.getSorting(filterRequest.tableId),
                        event: event,
                        dropDownValue: valueToPropagate,
                        easyFilterTypeId: easyFilterId ? ControlsGeneralEasyFilterControl.Control.getEasyFilterType(easyFilterId) : null,
                        completedCallback: () => { filterRequest.successCallback(); }
                    });
                });
            }
        }

        /**
         * Change page filter functionality
         * @param filterRequest -  always required filtering params
         * @param dropdownId - dropdown ID if required
         * @param filterId - filter ID if required
         * @param easyFilterId - easy filter ID if required
         */
        private static triggerChangePageFilter(filterRequest: IFilterRequest, dropdownId?: string, filterId?: string, easyFilterId?: string) : void {

            this.triggerChangePage((event: MouseEvent, page: number) => {
                void this.sendFilterRequest({
                    filter: filterId ? ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId) : null,
                    linkParams: {component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: []},
                    page: page,
                    sorting: Table.Helpers.getSorting(filterRequest.tableId),
                    event: event,
                    dropDownValue: dropdownId ? DropDownControl.Control.getCurrentDropDownValue(dropdownId) : null,
                    easyFilterTypeId: easyFilterId ? ControlsGeneralEasyFilterControl.Control.getEasyFilterType(easyFilterId) : null,
                    completedCallback: () => { filterRequest.successCallback(); }
                });
            });
        }

        /**
         * Trigger change page action
         * @todo use table id to be more specific in DOM
         * @param callback - callback on page click
         */
        public static triggerChangePage(callback: (event: MouseEvent, page: number) => void) : void {

            const pages = DOM.Parser.getHtmlElements('TableControl-pagination-inside-right-content-item-text', undefined, true);
            for (let i = 0; i < pages.length; i++) {
                pages[i].addEventListener("click", (event: MouseEvent) => {
                    const page = parseInt(DOM.Parser.getDataByNameFromElement('page', pages[i]));
                    callback(event, page);
                })
            }
        }

        /**
         * Sorting filter functionality
         * @param filterRequest -  always required filtering params
         * @param dropdownId - dropdown ID if required
         * @param filterId - filter ID if required
         * @param easyFilterId - easy filter ID if required
         */
        private static triggerSortFilter(filterRequest: IFilterRequest, dropdownId?: string, filterId?: string, easyFilterId?: string) : void {

            const tableElement = document.getElementById(filterRequest.tableId) as HTMLTableElement|null;
            if (tableElement === null) { return; }

            Table.Helpers.triggerOnSorting(tableElement, (sorting: SortingPayload, event: MouseEvent) => {
                void this.sendFilterRequest({
                    filter: filterId ? ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId) : null,
                    linkParams: {component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: []},
                    page: 0,
                    sorting: sorting,
                    event: event,
                    dropDownValue: dropdownId ? DropDownControl.Control.getCurrentDropDownValue(dropdownId) : null,
                    easyFilterTypeId: easyFilterId ? ControlsGeneralEasyFilterControl.Control.getEasyFilterType(easyFilterId) : null,
                    completedCallback: () => { filterRequest.successCallback(); }
                });
            });
        }

        /**
         * Filter change functionality
         * @param filterRequest -  always required filtering params
         * @param dropdownId - dropdown ID if required
         * @param filterId - filter ID
         * @param easyFilterId - easy filter ID if required
         */
        private static triggerFilterFilter(filterRequest: IFilterRequest, filterId: string, dropdownId?: string, easyFilterId?: string) : void {

            new ControlsGeneralFilterControl.Control(filterId, filterRequest.componentNameIncluded, (event: Event) => {
                void this.sendFilterRequest({
                    filter: ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId),
                    linkParams: {component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: []},
                    page: 0,
                    sorting: Table.Helpers.getSorting(filterRequest.tableId),
                    event: event,
                    dropDownValue: dropdownId ? DropDownControl.Control.getCurrentDropDownValue(dropdownId) : null,
                    easyFilterTypeId: easyFilterId ? ControlsGeneralEasyFilterControl.Control.getEasyFilterType(easyFilterId) : null,
                    completedCallback: () => { filterRequest.successCallback(); }
                }, filterId);
            }, filterRequest.successCallback);
        }

        /**
         * Initialize all triggers using filtering
         * @param filterRequest -  always required filtering params
         * @param dropdownId - dropdown ID if required
         * @param filterId - filter ID if required
         * @param easyFilterId - easy filter ID if required
         */
        public static triggerFilterTable(filterRequest: IFilterRequest, filterId?: string, dropdownId?: string, easyFilterId?: string) : void {

            if (filterId) { this.triggerFilterFilter(filterRequest, filterId, dropdownId, easyFilterId); }
            if (dropdownId) { this.triggerDropdownFilter(filterRequest, dropdownId, filterId, easyFilterId); }
            if (easyFilterId) { this.triggerEasyFilterFilter(filterRequest, easyFilterId, filterId, dropdownId); }
            this.triggerChangePageFilter(filterRequest, dropdownId, filterId, easyFilterId);
            this.triggerSortFilter(filterRequest, dropdownId, filterId, easyFilterId);
        }

        /**
         * Send form filter request with custom data
         * @param filterRequest - custom data
         * @param filterId
         */
        public static async sendFilterRequest(filterRequest: IFormFilterRequest, filterId?: string) : Promise<void> {

            if (filterId) {
                void ControlsForm.Controller.sendFormDataRequest(DOM.Parser.getElementByTag('form', DOM.Parser.getHtmlElement(filterId)) as HTMLFormElement, {
                    linkParameters: filterRequest.linkParams,
                    formData: {...filterRequest.filter, ...{
                            page: filterRequest.page,
                            sorting: filterRequest.sorting,
                            multiEditActive: filterRequest.multiEditActive ?? null,
                            easyFilterTypeId: filterRequest.easyFilterTypeId,
                            dropDownValue: filterRequest.dropDownValue ?? null,
                            filterActive: !filterId ? false : ControlsGeneralFilterControl.Utils.getFilterActiveByFilterId(filterId),
                        }},
                    event: filterRequest.event,
                    startCallback: () => {
                        ControlsGeneralFilterControl.Utils.disableEnableActionsInFilter(filterId, true);
                    },
                    successCallback: () => { if (filterRequest.successCallback) {
                        filterRequest.successCallback();
                    }},
                    completedCallback: () => { if (filterRequest.completedCallback) {
                        ControlsGeneralFilterControl.Utils.disableEnableActionsInFilter(filterId, false);
                        filterRequest.completedCallback();
                    }}
                });
            } else {
                void Networking.NetworkingController.createRequest({
                    type: RequestTypes.POST,
                    data: {...filterRequest.filter, ...{
                            page: filterRequest.page,
                            sorting: filterRequest.sorting,
                            easyFilterTypeId: filterRequest.easyFilterTypeId,
                            dropDownValue: filterRequest.dropDownValue ?? null,
                            multiEditActive: filterRequest.multiEditActive ?? null,
                            filterActive: false}
                    },
                    url: LinkBuilder.LinkBuilderController.composeLink(filterRequest.linkParams),
                    completedCallback: () => { if (filterRequest.completedCallback) { filterRequest.completedCallback(); } }
                });
            }
        }

        /**
         * Clear filter trigger initialization
         * @param filterFormClear - clear element
         * @param component - component id
         * @param successCallback - refresh triggers callback (mostly filterCompletedCallback)
         */
        static triggerClearFilter(filterFormClear: HTMLElement, component: string, successCallback: () => void) : void {

            filterFormClear.addEventListener('click', (event: MouseEvent) => {
                event.stopPropagation(); event.preventDefault();
                void Networking.NetworkingController.createRequest({
                    type: RequestTypes.GET,
                    url: LinkBuilder.LinkBuilderController.composeLink({component: component, method: "ClearFilter", parameters: []}),
                    successCallback: () => { successCallback(); }
                });
            });
        }

        /**
         * Trigger to send filter from formBox functionality
         * @param filterFormElement - filter form element
         * @param filterFormSubmit - filter form submit button element
         * @param callback - callback to send custom filter data
         */
        static triggerSendFilter(filterFormElement: HTMLFormElement, filterFormSubmit: HTMLButtonElement|HTMLInputElement, callback: (event: Event) => void) : void {

            FormValidator.validateForm({form: filterFormElement, forceSubmitButton: filterFormSubmit });
            filterFormSubmit.addEventListener('click', (event: Event) => { callback(event); });
        }
    }


    export class Control {

        static trigger(tableId?: string|null, inside?: HTMLElement) : void {

            const tableList = this.getTableElementList(tableId ?? null, inside ?? null);
            this.triggerMobileRowShowHideAction(tableList);
            this.triggerCopy(tableList);
        }

        private static getTableElementList(tableId: string|null, inside: HTMLElement|null) : HTMLElement[] {

            if (tableId) { return [DOM.Parser.getHtmlElement(tableId, inside ?? document.documentElement)]; }
            const elements = DOM.Parser.getHtmlElements(Config.tableControlElementClassName, inside ?? document.documentElement);
            const output : HTMLElement[] = [];
            for (let i = 0; i < elements.length; i++) { output.push(elements[i]); }
            return output;
        }

        private static triggerMobileRowShowHideAction(triggerTables: HTMLElement[]) : void {

            // For all table elements
            for (const table of triggerTables) {

                // For all table rows
                const triggerRows = DOM.Parser.getHtmlElements(Config.triggerRowTitle, table, true);
                for (let i = 0; i < triggerRows.length; i++) {

                    // Trigger clicked to main row on mobile
                    const row = triggerRows[i];
                    row.addEventListener('click', (event: MouseEvent) => {
                        event.preventDefault(); event.stopPropagation();
                        row.parentElement!.classList.toggle(Config.openedRowClassName);
                    })
                }
            }
        }

        private static triggerCopy(triggerTables: HTMLElement[]) : void {

            // For all table elements
            for (const table of triggerTables) {

                const copyColumns = table.querySelectorAll('.' + Config.copyColumnClassName);
                if (copyColumns.length === 0) { continue; }

                const content = DOM.Parser.getHtmlElementByClass(Config.copyColumnContentClassName)
                const button = DOM.Parser.getHtmlElementByClass(Config.copyColumnButtonClassName);
                button.addEventListener('click', (event: MouseEvent) => {
                    event.stopPropagation(); event.preventDefault();
                    void navigator.clipboard.writeText(content.innerText);
                    content.classList.add(Config.copyColumnCopiedClassName);
                    setTimeout(function() { content.classList.remove(Config.copyColumnCopiedClassName); }, 500);
                })
            }
        }
    }
}